import styled from 'styled-components';

import { Colors } from 'ui/constants/colors';

export const StringEnumerationFieldStyled = styled.div<{ isDisabled: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  & > .input {
    width: 100%;
    margin-right: 15px;
  }

  img {
    filter: ${({ isDisabled }) =>
      isDisabled
        ? 'invert(47%) sepia(7%) saturate(21%) opacity(0.3) hue-rotate(357deg) brightness(90%) contrast(92%)'
        : 'invert(47%) sepia(7%) saturate(21%) hue-rotate(357deg) brightness(90%) contrast(92%)'};
    cursor: pointer;
  }
`;

export const FieldErrorStyled = styled.span`
  display: block;
  margin-top: -10px;
  margin-bottom: 5px;
  text-align: center;
  color: ${Colors.RossoCorsa};
`;
